/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GenerateAttributeDescriptionRequest} from '../models/GenerateAttributeDescriptionRequest';

export interface GenerateAttributeDescription$Request {
    name: string;
    generateAttributeDescriptionRequest: GenerateAttributeDescriptionRequest;
}

export interface GenerateAttributeDescription$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const generateAttributeDescriptionRequest = createAction<PayloadData<void, GenerateAttributeDescription$Request>>('ATTRIBUTE_DESCRIPTION_GENERATOR_CONTROLLER__GENERATE_ATTRIBUTE_DESCRIPTION__REQUEST');
export const generateAttributeDescriptionSuccess = createAction<PayloadData<string, GenerateAttributeDescription$Request>>('ATTRIBUTE_DESCRIPTION_GENERATOR_CONTROLLER__GENERATE_ATTRIBUTE_DESCRIPTION__SUCCESS');
export const generateAttributeDescriptionFailure = createAction<PayloadData<Error, GenerateAttributeDescription$Request, true>>('ATTRIBUTE_DESCRIPTION_GENERATOR_CONTROLLER__GENERATE_ATTRIBUTE_DESCRIPTION__FAILURE');

export const generateAttributeDescriptionActions = [
    generateAttributeDescriptionRequest,
    generateAttributeDescriptionSuccess,
    generateAttributeDescriptionFailure
] as const;

/**
 * @param {string} meta.name Attribute name
 * @param {GenerateAttributeDescriptionRequest} meta.generateAttributeDescriptionRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const generateAttributeDescription = (meta: GenerateAttributeDescription$Request, config?: GenerateAttributeDescription$Config) => {
    return {
        CALL_API: {
            types: generateAttributeDescriptionActions,
            method: ApiMethods.POST,
            endpoint: `/ai/attribute-description-generator/run/${meta.name}`,
            TRANSPORT_REQUEST_BODY: meta.generateAttributeDescriptionRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/plain, application/json',
            }
        },
        ...meta
    }
};

